import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../shared/services/ecommerce/authService.service';
import { switchMap } from 'rxjs/operators';
export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
	const authService = inject(AuthService);
	// const token = authService.getToken();
	// ✅ Excluir peticiones al login y al dominio externo
	const isLoginRequest = req.url.includes('/Login');
	const isExternalRequest = req.url.startsWith('https://api-cms.movilbus.pe/');
	const isExternalRequest2 = req.url.startsWith('https://api.ipify.org/');

	if (isLoginRequest || isExternalRequest || isExternalRequest2) {
		return next(req); // no se modifica, se deja pasar
	}

	if (authService.isTokenExpired()) {
		return authService.autoLogin().pipe(
			switchMap(() => {
				const token = authService.getToken();
				const authReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;
				return next(authReq);
			})
		);
	}

	const token = authService.getToken();
	const authReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

	return next(authReq);

	// if (token) {
	// 	const cloned = req.clone({
	// 		setHeaders: {
	// 			Authorization: `Bearer ${token}`
	// 		}
	// 	});
	// 	return next(cloned);
	// }
	// return next(req);
};
